import { Button } from '@/components/ui/Button';

import { ExecutionProgress } from '../hooks/useExecutionSSE';

interface RunningStepProps {
  executionProgress: ExecutionProgress;
  onClose: () => void;
  onBackToConfig: () => void;
}

export function RunningStep({
  executionProgress,
  onClose,
  onBackToConfig,
}: RunningStepProps) {
  const { state, progress, completedCount, totalExecutions, error } =
    executionProgress;

  if (state === 'error' && error) {
    return (
      <div className="text-center py-8">
        <div className="text-5xl mb-4">⚠️</div>
        <div
          className="text-lg font-semibold mb-2"
          style={{ color: '#C41E3A' }}
        >
          Execution Error
        </div>
        <div
          className="p-6 rounded-lg mb-6 text-left"
          style={{
            background: 'rgba(196, 30, 58, 0.08)',
            border: '2px solid #C41E3A',
          }}
        >
          <div
            className="font-semibold mb-2 text-base"
            style={{ color: '#C41E3A' }}
          >
            Error Details:
          </div>
          <div className="text-sm leading-relaxed" style={{ color: '#C41E3A' }}>
            {error}
          </div>
        </div>
        <div className="flex gap-3 justify-center">
          <Button variant="secondary" onClick={onBackToConfig}>
            ← Back
          </Button>
          <Button variant="primary" onClick={onClose}>
            Close & Check Results
          </Button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="text-center py-8">
        <div className="text-5xl mb-4">🚀</div>
        <div className="text-lg font-medium mb-2" style={{ color: '#1A1A1A' }}>
          Execution in Progress
        </div>
        <div className="text-sm mb-6" style={{ color: '#6B6B6B' }}>
          {Math.round(completedCount)} of {totalExecutions} executions complete
        </div>

        {/* Progress Bar */}
        <div
          className="w-full max-w-md h-6 rounded-xl overflow-hidden mx-auto"
          style={{
            background: 'rgba(245, 240, 235, 0.5)',
            border: '1px solid #E8E0D8',
          }}
        >
          <div
            className="h-full flex items-center justify-center text-white text-xs font-semibold"
            style={{
              width: `${progress}%`,
              background: '#8B2332',
              transition: 'width 0.3s ease',
            }}
          >
            {progress > 0 && `${Math.round(progress)}%`}
          </div>
        </div>
      </div>

      {state === 'completed' || progress === 100 ? (
        <div
          className="p-4 rounded-lg mb-6 text-center text-sm"
          style={{
            background: 'rgba(46, 125, 74, 0.1)',
            border: '1px solid rgba(46, 125, 74, 0.3)',
            color: '#2E7D4A',
          }}
        >
          ✓ All executions completed! Redirecting to results...
        </div>
      ) : (
        <div
          className="p-4 rounded-lg mb-6"
          style={{ background: 'rgba(245, 240, 235, 0.5)' }}
        >
          <div className="text-sm" style={{ color: '#6B6B6B' }}>
            Executions are running. You can close this dialog and check progress
            in the Results page.
          </div>
        </div>
      )}

      <div className="flex justify-center">
        <Button variant="primary" onClick={onClose}>
          Done
        </Button>
      </div>
    </>
  );
}
